<template lang="pug">
  .number-quiz
    flip-card(
      @flip="onFlip"
      :disabled="state === states.answer || state === states.done || state === states.finished"
      )
      template(v-slot:front)
        card-back
          span.card-back-title(
            v-if="state === states.start"
          ) {{ quiz.number.title[locale] }}
          quiz-answer(
            v-else
            @done="result => updateState(states.done, result)"
          )
      template(v-slot:back)
        card-front(
          :number="quiz.number"
          :title="quiz.number.title[locale]"
          :text="quiz.number ? quiz.number.data.description[locale] : ''"
        )

</template>

<script>
import { mapState } from 'vuex'

import FlipCard from './FlipCard'
import CardBack from './CardBack'
import CardFront from './CardFront'
import QuizAnswer from './QuizAnswer'

const states = {
  start: 0,
  showNumber: 1,
  answer: 2,
  done: 3,
  finished: 4
};

export default {
  components:{
    FlipCard,
    CardFront,
    CardBack,
    QuizAnswer
  },
  props: {
    quiz: Object
  },
  data() {
    return {
      states,
      state: states.start
    };
  },
  computed: {
    ...mapState('locale', ['locale']),
  },
  methods: {
    onFlip({ flipped }) {
      if (flipped && this.state === this.states.start) {
        this.updateState(this.states.showNumber);
      }
      if (!flipped && this.state === this.states.showNumber) {
        this.updateState(this.states.answer);
      }
    },
    updateState(state, value=null) {
      if (this.state === this.states.finished) {
        return;
      }
      this.state = state;
      if (this.state === this.states.done) {
        this.$emit('done', this.quiz, value);
        this.state = this.states.finished;
      }
    }
  },
  watch: {
    quiz: function (newQuiz, oldQuiz) {
      if (newQuiz.id !== oldQuiz.id) {
        this.state = this.states.start;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  span.card-back-title
    font-font-weight 900
    font-size 24px
</style>
